import React from "react";
import ParticlesBackground from "../components/Effects/ParticlesBackground";

const World: React.FC = () => {
  return (
    <div>
      <ParticlesBackground />
      <h1>Mundo</h1>
      <p>Página del mundo en construcción...</p>
    </div>
  );
};

export default World;
